<script setup lang="ts">
/**
 * Une catégorie dans la vue « Tout » de l'onglet Objets : titre, nombre, et
 * « Voir tout » quand seul un aperçu est affiché.
 */
defineProps<{
  title: string;
  count: number;
  /** Seul un aperçu est affiché : propose d'ouvrir la catégorie. */
  truncated: boolean;
}>();

const emit = defineEmits<{ (e: "see-all"): void }>();
</script>

<template>
  <section class="objects-section">
    <header class="section-header">
      <span class="section-title">{{ title }}</span>
      <span class="section-count">{{ count }}</span>
      <button
        v-if="truncated"
        type="button"
        class="section-see-all"
        @click="emit('see-all')"
      >
        {{ $t("canvas:settings.objects.seeAll") }} ›
      </button>
    </header>
    <slot />
  </section>
</template>

<style lang="scss" scoped>
.objects-section + .objects-section {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid var(--canvas-border);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.section-title {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
}

.section-count {
  font-size: 10.5px;
  color: rgba(255, 255, 255, 0.35);
}

.section-see-all {
  margin-left: auto;
  padding: 4px 6px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--canvas-btn-active-bg);
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background-color: var(--canvas-btn-hover-bg);
  }
}
</style>
